
import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { MemberPermission } from './types/memberTypes';

interface MemberPermissionsTooltipProps {
  permissions?: MemberPermission[];
  getCheckedPermissionsCount: (permissions?: MemberPermission[]) => number;
  getCheckedPermissionNames: (permissions?: MemberPermission[]) => string[];
  children: React.ReactNode; // Add the children prop
}

const MemberPermissionsTooltip: React.FC<MemberPermissionsTooltipProps> = ({
  permissions,
  getCheckedPermissionsCount,
  getCheckedPermissionNames,
  children
}) => {
  const checkedCount = getCheckedPermissionsCount(permissions);
  const permissionNames = getCheckedPermissionNames(permissions);
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent className="bg-white p-2 max-w-xs border shadow-md rounded-md">
          <div className="text-sm font-medium mb-1">Permissions ({checkedCount})</div>
          <ul className="text-xs space-y-1 list-disc pl-4">
            {permissionNames.map((name, index) => (
              <li key={index}>{name}</li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default MemberPermissionsTooltip;
